import { Queue } from '~/apps/smartsend/lib/helpers/ApiCache';

const maxQueue = Infinity;
export const DefaultRuleManagerQueue = new Queue(10, maxQueue);
